export default __webpack_public_path__ + "static/media/PrishtinaJet-LOGO.ef21da50.svg";